import { render, staticRenderFns } from "./MiddleTubiao.vue?vue&type=template&id=6f8e1332&scoped=true&"
import script from "./MiddleTubiao.vue?vue&type=script&lang=js&"
export * from "./MiddleTubiao.vue?vue&type=script&lang=js&"
import style0 from "./MiddleTubiao.vue?vue&type=style&index=0&id=6f8e1332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e1332",
  null
  
)

export default component.exports